export default from './LastMessage';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerCard/components/LastMessage/index.js